export default [
    {
        path: '/amenities',
        name: 'amenities',
        meta: {
            layout: 'dashboard'
        },
        component: () => import('VIEWS/Catalogs/Amenities.vue')
    }
]